/** 跨端共用的固定常量（取自 TECH-BRIEF §1、§3、§4）。 */

/** 用户端 API 前缀 */
export const USER_API_PREFIX = '/api/v1';
/** 后台 API 前缀 */
export const ADMIN_API_PREFIX = '/admin-api/v1';

/** 用户端会话 cookie */
export const USER_SESSION_COOKIE = 'nx_s';
/** 后台会话 cookie */
export const ADMIN_SESSION_COOKIE = 'nx_as';

/** 非 GET 请求必须携带的请求头（小写）与取值 */
export const CLIENT_HEADER_NAME = 'x-nexora';
export const CLIENT_HEADER_VALUE = '1';

/** 分页每页上限（TECH-BRIEF §4：每页 ≤50 条） */
export const MAX_PAGE_LIMIT = 50;
